import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  Button,
  Table,
  Input,
} from "reactstrap";

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Autocomplete from "../controls/_Autocomplete";
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ButtonExt from "../controls/ButtonExt"
import * as common from "../../lib/common"
import { BtnPermissions } from "../../lib/BtnPermissions"
import orderConstants, * as constants from "./constants"
import NumberCtr from "./_NumberCtr"

class OrderControls extends Component {

  render() {
    const {
      requesting,
      warnings,
      messages,
      errors,
      orderInfor,
      mode,
      isKhoaTichDiem,
      isKhoaChietKhauTongDon
    } = this.props

    // kiểm tra xem đang ở mode edit hay không
    const isEditMode = mode === orderConstants.MODE.IN_EDIT
    // kiểm tra xem đang có quyền chỉnh sửa hay không
    const isEditable = !isEditMode || (orderInfor && orderInfor.is_editable)
    // kiểm tra xem đã có thuốc nào hay chưa
    const isHasItems = this.props.items && this.props.items.length > 0
    // bo chiet khau de tich diem hay khong
    const isBoCk = orderInfor && orderInfor[constants.FormFiels.BoChietKhau]

    const mulPoint = (point, soLuong) => {
      if (!soLuong || soLuong <= 0) return 0
      if (!point || point <= 0) return 0
      return point * soLuong
    }
    const sumAll = () => {
      const items = this.props.items || [];
      return (common.sum(items, "chiet_khau") + common.sum(items, "thanh_tien")).toLocaleString()
    }
    const genTongCKDon = e => {
      const orderTotal = this.props.orderTotal || {};
      if (typeof orderTotal != "undefined") {
        return (
          <Fragment>
            <tr key={"ft2"}>
              <td colSpan="5" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Tổng tiền sau CK: </span>
              </td>
              <td></td>
              <td scope="col" className="text-right font-weight-bold">
                {sumFee()}
              </td>
            </tr>
            <tr key={"ft3"}>
              <td colSpan="5" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Chiết khấu thêm tổng đơn: </span>
              </td>
              <td scope="col" className="text-right font-weight-bold">
                {(orderTotal.CpCkPercent || 0).toLocaleString()}%
              </td>
              <td scope="col" className="text-right font-weight-bold">
                {(orderTotal.ChietKhauDoanhSo || 0).toLocaleString()}
              </td>
            </tr>
            <tr key={"ft4"}>
              <td colSpan="5" scope="col" className="text-right">
                <span className="text-primary font-weight-bold">Tổng thanh toán: </span>
              </td>
              <td scope="col" className="text-right font-weight-bold"></td>
              <td scope="col" className="text-right font-weight-bold">
                {(orderTotal.TongTien || 0).toLocaleString()}
              </td>
            </tr>
          </Fragment>
        )
      }
    }
    const getItems = e => {
      const items = this.props.items || [];
      return items.map((item, idx) => {
        const chietKhau = item.chiet_khau || 0
        const thanhTien = (item.gia_ban * item.so_luong) - chietKhau
        return (
          <tr key={idx}>
            <td scope="col" className="text-justify">
              <Button title={"Kích để sửa thông tin"} className={`btn btn-link border-0 pl-0`} onClick={e => this.props.handleEditItem(item)}>
                {`${item.sku}/ ${item.ten}`}
              </Button>
            </td>
            <td scope="col" className="text-justify">
              {item.nhom_hang}
            </td>
            <td scope="col" className="text-justify">
              {item.dvt}
            </td>
            <td scope="col" className="text-right">
              {(item.so_luong || 0).toLocaleString()}
            </td>
            <td scope="col" className="text-right">
              {(item.gia_ban || 0).toLocaleString()}
            </td>
            <td scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
              {item.diem}
            </td>
            <td scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
              {chietKhau.toLocaleString()}
            </td>
            <td scope="col" className="text-right">
              {thanhTien.toLocaleString()}
            </td>
            <td scope="col" className="text-right">
              <Button size="sm" className={`btn btn-danger`} onClick={e => this.props.handleRemoveItem(item)}>
                <i className="fa fa-trash-o"></i>
              </Button>
            </td>
          </tr>
        )
      });
    }

    const mapToCustomers = (datas) => {
      return datas.map((item) => {
        let label = item.Ten
        if (item.Ma && item.Ma !== '') {
          label += `/${item.Ma}`
        }

        return {
          label: label,
          value: item.Id,
          dienThoai: item.DienThoai,
          diaChi: item.DiaChi
        }
      })
    }

    const mapToProducts = (datas) => {
      return datas.map((item) => {
        const label = item.Sku ? `${item.Sku}/ ${item.Ten}` : item.Ten
        return {
          label: label,
          value: item.Id,
          dvt: item.DvtTen,
          quantity: item.TonKho,
        }
      })
    }

    const getListKhos = (items) => {
      return items.map((item, idx) => {
        return (
          <option key={idx} label={item.Tem} value={item.Id}>{item.Ten}</option>
        )
      })
    }

    const sumQuantity = () => {
      const items = this.props.items || [];
      return common.sum(items, "so_luong").toLocaleString()
    }
    const sumRefun = () => {
      const items = this.props.items || [];
      return common.sum(items, "chiet_khau").toLocaleString()
    }
    const sumFee = () => {
      const items = this.props.items || [];
      return common.sum(items, "thanh_tien").toLocaleString()
    }
    const sumScore = () => {
      const items = this.props.items || [];
      return common.sum(items, "diem").toLocaleString()
    }
    return (
      <BlockUi tag="div" blocking={requesting} >
        <div className="col-sm-7 col-md-8 pull-left">
          <Card>
            <CardBody className="p-1">
              <div className="col-sm-12">
                {isEditMode && !isEditable && (
                  <div className="col-sm-12 mb-2 pull-left">{`Đơn hàng đang được chỉnh sửa bởi ${orderInfor.lock_by}`}</div>
                )}
                <div className="col-sm-7 col-7 mb-2 pull-left">
                  {!isEditMode && !isHasItems && (
                    <CheckboxTreeList
                      placeholder={`--Chọn nhân viên--`}
                      nodes={this.props.users}
                      isMultiChoice={false}
                      checked={this.props.usersChecked}
                      onHandleClick={this.props.onHandleClick}
                      onHandleRemove={this.props.onHandleRemove}
                      onChoice={this.props.onHandleChoice}
                      tabIndex={1}
                    />
                  )}
                  {(isEditMode || isHasItems) && (
                    <span>Nhân viên: <b>{orderInfor.ten_nhan_vien}</b></span>
                  )}
                </div>
                <div className="col-sm-5 col-5 mb-2 pull-left">
                  {!isEditMode && !isHasItems && (
                    <select tabIndex={2} disabled={isHasItems} className="form-control" value={orderInfor.kho_xuat_id} onChange={e => this.props.handleKhoChange(e)}>
                      <option value="">--Kho xuất--</option>
                      {getListKhos(this.props.khoXuats)}
                    </select>
                  )}
                  {(isEditMode || isHasItems) && (
                    <span>Kho: <b>{orderInfor.ten_kho}</b></span>
                  )}
                </div>
                <div className="col-sm-7 mb-2 pull-left">
                  <Autocomplete
                    name="thuoc"
                    placeholder="Tên/ mã hàng"
                    setFocus={false}
                    selectOnTab={true}
                    tabIndex={3}
                    formatOptionLabel={this.props.thuocFormatOptionLabel}
                    formatNoOptionLabel={this.props.thuocFormatNoOptionLabel}
                    handleClearClick={this.props.thuocHandleClearClick}
                    handleChange={this.props.thuocHandleChanged}
                    onSelection={this.props.productHandleSelectChange}
                    suggestions={mapToProducts(this.props.thuocs)}
                    onRef={(ctl) => this.props.setProductCtl(ctl)}
                  />
                </div>
                <div className="col-sm-5 col-xs-12 pull-left">
                  <div className="col-md-7 col-8 quantity-wrapper mb-2 pull-left">
                    <NumberCtr
                      name={"quantity"}
                      value={this.props.quantity}
                      defaultValue={1}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      decimalScale={0}
                      type="tel"
                      tabIndex={4}
                      allowEmptyFormatting={true}
                      className={"form-control order-input-sl price"}
                      onClick={this.props.numberOnclick}
                      onValueChange={this.props.handleQuantityChange}
                      onKeyDown={this.props.handleQuantityKeyPress}
                      downClick={this.props.downQuantityClick}
                      upClick={this.props.upQuantityClick}
                    />
                  </div>
                  <div className="col-md-4 col-4 add-item-wrapper mb-2 pull-left">
                    <Button tabIndex={5} className="btn_add_item" color="primary" disabled={!this.props.enabledAddItem} onClick={this.props.handleAddItem}>
                      <i className="fa fa-arrow-down mr-1"></i><span className="btn_add_item_text">Thêm</span></Button>
                  </div>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className={"msg-add-item-warning mb-2 mt-2"}>
                <div className="col-sm-12">
                  {!!warnings.length && (
                    <Messages className={"msg-add-item-warning-content"} messages={warnings} />
                  )}
                </div>
              </div>
              <div className="col-sm-12 mb-2">
                <Table hover responsive className="table-outline table-sm mb-0">
                  <thead className="thead-default">
                    <tr className="hide-in-mobile">
                      <th scope="col" className="text-justify">
                        Tên thuốc
                      </th>
                      <th scope="col" className="text-justify">
                        Nhóm thuốc
                      </th>
                      <th scope="col" className="text-justify">
                        ĐVT
                      </th>
                      <th scope="col" className="text-right">
                        Số lượng
                      </th>
                      <th scope="col" className="text-right">
                        Đơn giá
                      </th>
                      <th scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        Điểm
                      </th>
                      <th scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        Chiết khấu
                      </th>
                      <th scope="col" className="text-right">
                        Thành tiền
                      </th>
                      <th scope="col" className="text-right">
                        &nbsp;
                      </th>
                    </tr>
                    <tr className="show-in-mobile">
                      <th scope="col" className="text-justify">
                        Tên
                      </th>
                      <th scope="col" className="text-justify">
                        Nhóm
                      </th>
                      <th scope="col" className="text-justify">
                        ĐVT
                      </th>
                      <th scope="col" className="text-right">
                        S/lượng
                      </th>
                      <th scope="col" className="text-right">
                        Đ/giá
                      </th>
                      <th scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        Điểm
                      </th>
                      <th scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        C/khấu
                      </th>
                      <th scope="col" className="text-right">
                        T/Tiền
                      </th>
                      <th scope="col" className="text-right">
                        &nbsp;
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getItems()}
                  </tbody>
                  <tfoot className="thead-default">
                    <tr key={"ft1"}>
                      <td colSpan="2" scope="col" className="text-right">
                        <span className="text-primary font-weight-bold">Tổng cộng: </span>
                      </td>
                      <td colSpan="2" scope="col" className="text-right font-weight-bold">
                        {sumQuantity()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        &nbsp;
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumScore()}
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumRefun()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        {sumAll()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        &nbsp;
                      </td>
                    </tr>
                    {
                      genTongCKDon()
                    }
                  </tfoot>
                </Table>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-sm-5 col-md-4 pull-left">
          <Card>
            <CardBody className="p-1">
              <div className="col-sm-12">
                <div className="col-sm-12 mb-1">
                  {!isEditMode && (
                    <Autocomplete
                      className="customer"
                      name="customer"
                      placeholder="Tên khách hàng, số điện thoại"
                      setFocus={false}
                      clearOnSelection={true}
                      tabIndex={6}
                      formatOptionLabel={this.props.formatOptionLabel}
                      formatNoOptionLabel={this.props.formatNoOptionLabel}
                      onSelection={this.props.onCustomerSelectChanged}
                      suggestions={mapToCustomers(this.props.customers)}
                    />
                  )}
                </div>
                <div className="col-sm-12  mb-1">
                  <div className="input-group input-group-md display-table">
                    <div className="input-group-prepend  display-table-cell">
                      <span className="input-group-text" htmlFor="ten_khach_hang">Tên</span>
                    </div>
                    <div className={"form-control display-table-cell"}>
                      <span><b>{orderInfor.ten_khach_hang}</b></span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12  mb-1">
                  <div className="input-group input-group-md display-table">
                    <div className="input-group-prepend  display-table-cell">
                      <span className="input-group-text" htmlFor="dia_chi">Địa chỉ</span>
                    </div>
                    <div className={"form-control display-table-cell"}>
                      <span><b>{orderInfor.dia_chi}</b></span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-1">
                  <div className="input-group input-group-md display-table">
                    <div className="input-group-prepend  display-table-cell">
                      <span className="input-group-text" htmlFor="dien_thoai">Điện thoại</span>
                    </div>
                    <div className={"form-control display-table-cell"}>
                      <span><b>{orderInfor.dien_thoai}</b></span>
                    </div>
                  </div>
                </div>
                {this.props.typeOfOrder === constants.default.TYPEOF_ORDER.FOR_DEFAULT && (
                  <div className="col-sm-12 mb-1">
                    <div className="input-group input-group-md display-table">
                      <div className="input-group-prepend  display-table-cell">
                        <span className="input-group-text" htmlFor="hd_tham_gia">HĐ tham gia</span>
                      </div>
                      <div className={"form-control display-table-cell"}>
                        <span><b>{orderInfor.hd_tham_gia}</b></span>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-12 mb-1">
                  <div className="input-group input-group-md display-table">
                    <div className="input-group-prepend display-table-cell">
                      <span className="input-group-text" htmlFor="diem_tich_luy">Điểm tích luỹ</span>
                    </div>
                    <div className={"form-control display-table-cell"}>
                      <span><b>{(orderInfor.diem_tich_luy || 0).toLocaleString()}</b></span>
                      <span className="text-success ml-1">(Điểm)</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 mb-1">
                  <div className="input-group input-group-md display-table">
                    <div className="input-group-prepend display-table-cell">
                      <span className="input-group-text" htmlFor="ds_tich_luy">D/Số tích luỹ</span>
                    </div>
                    <div className={"form-control display-table-cell"}>
                      <span><b>{(orderInfor.ds_tich_luy || 0).toLocaleString()}</b></span>
                      <span className="text-success ml-1">(Đồng)</span>
                    </div>
                  </div>
                </div>
                {isEditMode && (
                  <div className="col-sm-12  mb-1">
                    <div className="input-group input-group-md display-table">
                      <div className="input-group-prepend  display-table-cell">
                        <span className="input-group-text" htmlFor="ngay_lap">Ngày lập</span>
                      </div>
                      <div className={"form-control display-table-cell"}>
                        <span><b>{common.formatDateTime(orderInfor.ngay_lap, "DD-MM-YYYY")}</b></span>
                      </div>
                    </div>
                  </div>
                )}
                <div>
                {
                  !isKhoaTichDiem &&
                  <div className="col-4 pull-left mb-1">
                    <label className="input-group-text text-danger" htmlFor="bo_chiet_khau">
                      <Input className="form-checkbox-append"
                        onChange={e => this.props.handleBoCkCreated(e)}
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        type="checkbox" name="bo_chiet_khau"
                        id="bo_chiet_khau"
                        tabIndex={8}
                        checked={orderInfor.bo_chiet_khau || false} />
                      &nbsp;HĐ tích điểm
                    </label>
                  </div>
                }
                <div className="col-4 pull-left mb-1">
                  <label className="input-group-text text-danger mb-1" htmlFor="xuat_hoa_don">
                    <Input className="form-checkbox-append"
                      onChange={e => this.props.handleXuatHDCreated(e)}
                      aria-label="Small"
                      aria-describedby="inputGroup-sizing-sm"
                      type="checkbox" name="xuat_hoa_don"
                      id="xuat_hoa_don"
                      tabIndex={9}
                      checked={orderInfor.xuat_hoa_don || false} />
                    &nbsp;Xuất hóa đơn
                  </label>
                </div>
                {
                  !isKhoaChietKhauTongDon &&
                  <div className="col-4 pull-left mb-1">
                    <label className="input-group-text text-danger" htmlFor="bo_ck_tong_don">
                      <Input className="form-checkbox-append"
                        onChange={e => this.props.handleBoCkTongDonCreated(e)}
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        type="checkbox" name="bo_ck_tong_don"
                        id="bo_ck_tong_don"
                        tabIndex={8}
                        checked={orderInfor.bo_ck_tong_don || false} />
                      &nbsp;Bỏ CK tổng đơn
                    </label>
                  </div>
                }
                <div className="clearfix"></div>
                </div>
                <div className="mb-1">
                  <Input tabIndex={10} type="textarea" maxLength={250} name="tenKhachHang" placeholder="Ghi chú" value={orderInfor.ghi_chu || ''} onChange={e => this.props.handleNoteCreated(e)} />
                  <div className="clearfix"></div>
                </div>
              </div>
              <div>
                <div className="col-sm-12">
                  {!requesting && !!errors.length && (
                    <Errors message="Failure to signup due to:" errors={errors} />
                  )}
                  {!requesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </div>
              </div>
              <div>
                <div className="col-sm-12">
                  <div className="btn-group float-right btn-edit-group" role="group">
                    <Button tabIndex={11} className="btn btn-secondary mr-1 btn-xs-left" onClick={() => this.props.return2List()}>
                      <i className="fa fa-long-arrow-left"></i><span className="d-sm-inline">&nbsp;Quay về</span>
                    </Button>
                    {isEditable && (
                      <ButtonExt tabIndex={12} isDisabled={(requesting || !isHasItems)} size="md" btnClass="pull-right btn-success btn-save" btnClick={this.props.save}
                        iconClass="fa-save" displayText="Lưu" permission={BtnPermissions.DonHang.SAVE_ORDER} />
                    )}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="clearfix"></div>
      </BlockUi>
    )
  }
}

export default OrderControls;



// WEBPACK FOOTER //
// ./src/views/Order/OrderControls.js